import React from 'react';

import {formatDate} from 'utils/datetime';
import Table from 'components/Table';
import Money from 'components/Money';

import './styles.css';

const PaymentScheduleTable = ({
  schedule: {billingCycle: {invoiceItems}, totalDays, totalValue}
}) => (
  <div className="PaymentScheduleTable">
    <Table>
      <Table.Header>
        <Table.HeaderItem heading="Date" className="dateHeading" />
        <Table.HeaderItem
          heading="Description"
          className="descriptionHeading"
        />
        <Table.HeaderItem heading="Type" className="typeHeading" />
        <Table.HeaderItem heading="Days" className="daysHeading" />
        <Table.HeaderItem heading="Balance" className="balanceHeading" />
      </Table.Header>
      <Table.Body>
        {invoiceItems.map(invoice => (
          <Table.Row key={invoice.uuid} className="paymentScheduleTableRow">
            <Table.Cell>{formatDate(invoice.due)}</Table.Cell>
            <Table.Cell className="descriptionCell">
              Licence fee for {formatDate(invoice.start)} -{' '}
              {formatDate(invoice.end)}
            </Table.Cell>
            <Table.Cell className="typeCell">{invoice.type}</Table.Cell>
            <Table.Cell className="daysCell">{invoice.days}</Table.Cell>
            <Table.Cell className="balanceCell">
              <Money amount={invoice.amount} />
            </Table.Cell>
          </Table.Row>
        ))}
        <Table.Row className="paymentScheduleTableRow rentScheduleSummaryRow">
          <Table.Cell />
          <Table.Cell className="descriptionCell" />
          <Table.Cell className="typeCell" />
          <Table.Cell className="daysCell">{totalDays}</Table.Cell>
          <Table.Cell className="balanceCell">
            <Money amount={totalValue} />
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  </div>
);

export default PaymentScheduleTable;
